export const getSearchData = (state) =>
  state.search.results.find((i) => i.title === 'users').data || [];

export default {};
